import {mapState, mapGetters, mapMutations, mapActions} from 'vuex';
import {isEmpObj, pageViewTracker, GetQueryString} from '../lib/units';

import {doWxShareConfig, wxConfig} from '../lib/wxActions';
import { getPlatform } from '@/frontend-lib/tools/getPlatform'
import Bridge from "@/frontend-lib/lib/Bridge";
import APIS from "@/apis"
import PageGrayFilter from '@/frontend-lib/component/PageGrayFilter/index'

export default {
    // beforeRouteEnter(to, from, next){
    //     next(() => {
    //         window.lastVistedPage = from;
    //     });
    // },
    beforeRouteLeave(to, from, next){
        // 页面即将离开的时候将自己设置为lastVistedPage, beforeRouteEnter 是在mounted之后发生的，所以无效
        window.lastVistedPage = from;
        next();
    },
    data() {
        return {
            [`ENTER_TIME`]: null,
            [`ALLOW_SHARE`]: true, // 页面通过重写此项，隐藏一切分享操作
            [`ALLOW_APP_SHARE`]: true, // 页面通过重写此项，隐藏app分享操作
            [`ALLOW_SHARE_WXPYQ`]: null, // 是否能够分享到朋友圈
            [`PV_BY_SELF`]: false, // 是否另外自行触发PV方法
            [`HEIGHT_UPDATE`]: false,
        }
    },
    computed: {
        ...mapState([
            'channelConfig',
            'channelId',
            'userInfo',
            'isWxApp',
            'wxMiniAppSessionKey',
            'woNiuUnique',
        ]),
        ...mapGetters({
            UID: 'COOKIE_UID'
        }),
        woNiuSourceName() {
            let r = ''
            let woNiuUnique = JSON.parse(localStorage.getItem('woNiuUnique'))
            let hash = location.hash
            if (this.woNiuUnique || woNiuUnique) {
                r = this.woNiuUnique ? this.woNiuUnique : woNiuUnique
            } else if(this.$route.query.unique) {
                r = this.$route.query.unique
            } else if (hash.indexOf('unique') > -1) {
                let index = hash.indexOf('unique')
                let unique = hash.slice(index).split('&')[0]
                r = unique ? unique.split('=')[1] : ''
            }
            return r
        },
        PVaddOn() {
            return {}
        },
        wxShareConfig() {
            // 配置微信分享的参数, 每个页面应该自行配置，这里是配置一个保底的
            const that = this;
            return {
                title: that.channelConfig.siteName,
                link: `${location.origin}${location.pathname}?channelId=${that.channelId}#${that.$route.path}`,
                imgUrl: that.channelConfig.logoUrl ? that.channelConfig.logoUrl : 'http://static.xinli001.com/static-ceping-wz/static/images/logo-brain.png',
                desc: '专业、有趣、好玩的心理测评，用心理学探索未知的自己。',
                success: function () {
                    // 埋点
                    window.TRACKER.sharePage(that.$route.meta.title);
                },
                cancel: function () {
                }
            }
        },
        pageWxMiniAppSessionKey(){
            let result = this.$route.query.sessionKey?this.$route.query.sessionKey:'';

            return result;
        },
        userKey(){
            console.log((this.$route.query.userKey && this.$route.query.userKey!='null'? this.$route.query.userKey:'') || localStorage.getItem('yxl_cp_userkey') || '')
            return (this.$route.query.userKey && this.$route.query.userKey!='null'? this.$route.query.userKey:'') || localStorage.getItem('yxl_cp_userkey') || '';
        }
    },
    created() {
        const that = this;
        // 设置UID
        that.setUID(that.$route.query.uid);
        if (this.$route.params.channelId) {
            that.channelIdUpdate(this.$route.params.channelId);
        }else{
            if (isEmpObj(that.channelConfig) & (that.channelId != null)) {
                that.channelIdUpdate(that.channelId === 'null'? 1: that.channelId);
            }
        }


        if(this.ALLOW_SHARE_WXPYQ === null) {
            this.ALLOW_SHARE_WXPYQ = this.ALLOW_SHARE;
        };
    },
    mounted() {
        const that = this;
        that.ENTER_TIME = new Date();
        // console.log(this.$route)
        if (!this.PV_BY_SELF) {
            this.pageViewTracker({
                from: window.lastVistedPage,
                to: this.$route,
                enterTime: this.ENTER_TIME,
                addOn: this.PVaddOn,
            })
        }
        console.log('page mounted')
        //头条快手App不需要更新微信配置 && 微博免登不需要更新
        let IS_FETCH_WX = !this.TOUTIAOAPP && !this.WEIBO_NOTLOGIN && !this.KUAISHOU_APP
        if (IS_FETCH_WX) {
            if (this.channelId == 3064) {
                return
            }
            that.pageInitWx();
        }
        if(this.platform.isYixinliApp || this.platform.isCeShiApp) {
            console.log('page mounted, set app share');
            this.appShareInit();
        }
        // 页面加载channelId自检
        let channelId = 1;
        if (this.$route.params.channelId) {
            channelId = this.$route.params.channelId
        }else{
            if(that.$route.query.channelId) {
                channelId = (that.$route.query.channelId && that.$route.query.channelId!=='null')? that.$route.query.channelId: 1;
            } else if (GetQueryString('channelId')) {
                channelId = (GetQueryString('channelId') && GetQueryString('channelId')!=='null')? GetQueryString('channelId'): 1;
            }
        }

        if ((channelId != null) && (channelId != this.channelId)) {
            that.channelIdUpdate(channelId);
        }

      // 判断是否小程序过来的页面，并且全局保存

      this.checkFromWxApp()
    },
    updated(){
        const el = document.getElementById('app');
        if(!this.HEIGHT_UPDATE) {
            /*
             *  为了兼容IOS，Safari的bug-> 在列表按返回白屏，每次返回都人工滚动1px。
             *  参考资料：https://github.com/vuejs/vue/issues/6954
             */
            this.$nextTick(()=> {
                let originHeight = el.getAttribute('oldHeight')?el.getAttribute('oldHeight'):el.offsetHeight;
                // el.setAttribute('oldHeight', originHeight);
                el.style.height = `${originHeight + 1}px`;

                setTimeout(() => {
                    el.removeAttribute('style');
                    this.HEIGHT_UPDATE = true;
                }, 200);
            });
        }

    },
    beforeDestroy(){

        this.pageViewTracker({
            from: window.lastVistedPage,
            to: this.$route,
            enterTime: this.ENTER_TIME,
            leaveTime: new Date(),
            addOn: this.PVaddOn,
            isLeave: true,
        });
        document.getElementById('app').removeAttribute('style');
    },
    watch: {
        'channelId': function (newVal) {
            const that = this;
            if (newVal == undefined | newVal == 'null') {
                return;
            }
            that.channelIdUpdate(newVal);
        },
        'wxConfig': function () {
            this.pageInitWx();
        },
        'wxShareConfig': function (newVal) {
            this.doWxShareConfig(this.wxShareConfig);
            if(this.platform.isYixinliApp) {
                this.appShareInit();
            }
        },
        '$route.query.uid': function (newVal) {
            this.setUID(newVal);
        },
        'ALLOW_SHARE': function () {
            this.pageInitWx();
        },
        'ALLOW_APP_SHARE': function () {
            this.pageInitWx();
        },
    },
    methods: {
        ...mapMutations(['setIsWxApp','setWxMiniAppSessionKey']),
        checkFromWxApp(){
            console.log('this.$route.query.appCode',this.$route.query)
            document.addEventListener('UniAppJSBridgeReady', function() {
                uni.postMessage({
                    data: {
                        action: 'message'
                    }
                });
            });
          // 判断是否小程序过来的页面，并且全局保存
          if(this.$route.query.appCode == 16) {
            this.setIsWxApp(true);
          }
          if(this.isWxApp & (this.pageWxMiniAppSessionKey != '')) {
            console.error(this.pageWxMiniAppSessionKey);
            this.setWxMiniAppSessionKey(this.pageWxMiniAppSessionKey);
            // 非免登
            if (!this.CHANNEL_NOT_LOGIN && !this.isWxApp) {
                this.getUserInfo(this.channelId)
            }
          }
        },
        pageViewTracker,
        appShareInit(){
            let myBridge = new Bridge({
                methods: [{
                    method: 'topFuncBtn',
                    callback: (option) => {
                        if (option.name === 'shareReportBtn') {
                            myBridge.call('shareReport', {
                                title: this.wxShareConfig.title,
                                desc: this.wxShareConfig.desc,
                                link: this.wxShareConfig.link,
                                imgUrl: this.wxShareConfig.imgUrl
                            });

                            if(this.appShareCallback && typeof this.appShareCallback === 'function') {
                                this.appShareCallback();
                            }

                        }
                    }
                }]
            });

            if(this.ALLOW_SHARE && this.ALLOW_APP_SHARE) {
                console.log('设置APP分享', {
                    btnList: [{
                        name: 'shareReportBtn',
                        visible: 1,
                        showName: '分享'
                    }]
                })
                myBridge.call('topFuncBtnConfig', {
                    btnList: [{
                        name: 'shareReportBtn',
                        visible: 1,
                        showName: '分享'
                    }]
                })
            } else {
                console.log('设置APP不要分享', {
                    btnList: []
                })
                myBridge.call('topFuncBtnConfig', {
                    btnList: []
                })
            }
        },
        pageInitWx(){
            console.log('初始化微信分享')
            const that = this;
            let ISN_NONE_SHOW_WX = isEmpObj(that.wxConfig) || this.TOUTIAOAPP || this.WEIBO_NOTLOGIN || this.KUAISHOU_APP
            if ((ISN_NONE_SHOW_WX || this.isAfterTestPay) && !this.isTfWechat) {
                return;
            }
            wxConfig(that.wxConfig).then(() => {
                return that.doWxShareConfig(that.wxShareConfig);
            }).then(() => {
                let menuList = [
                    'menuItem:share:qq',
                    'menuItem:share:weiboApp',
                    'menuItem:share:QZone',
                    "menuItem:openWithSafari",
                    "menuItem:share:appMessage",
                    "menuItem:share:facebook",
                    "menuItem:copyUrl",
                ];

                wx.ready(function () {
                    console.log('ALLOW_SHARE', that.ALLOW_SHARE)
                    if (that.ALLOW_SHARE) {
                        if (!!that.ALLOW_SHARE_WXPYQ) {
                            menuList.push("menuItem:share:timeline");
                        }
                        wx.showMenuItems({
                            menuList
                        });
                        console.log('showMenuItems',menuList);
                    } else {
                        if (!that.ALLOW_SHARE_WXPYQ) {
                            menuList.push("menuItem:share:timeline");
                        }
                        wx.hideMenuItems({
                            menuList
                        });
                        // console.log('hideMenuItems',menuList);
                    }
                });
            }).catch(() => {
                that.getWechatData({
                    channelId: that.channelId,
                    query: this.$route.query,
                }).then(() => {
                    return wxConfig(that.$store.state.wxConfig)
                }).then(() => {
                    that.doWxShareConfig(that.wxShareConfig);
                });
            });
        },
        async channelIdUpdate(channelId) {
            const that = this;
            console.info('渠道ID发生变化');
            that.setChannelId(channelId);
            let UPDATA_WX = !this.TOUTIAOAPP && (!this.WEIBO_NOTLOGIN || this.isTfWechat) && !this.KUAISHOU_APP
            if (UPDATA_WX) {
                that.getWechatData({
                    channelId: channelId,
                    query: this.$route.query,
                });
            }
            that.getChannelMsg({
                params: {
                    channelId: channelId
                }
            }).then(async (res) => {
                console.log('渠道ID res', res)
                if (!channelId) {
                    return
                }
                if (channelId && res.channelMsg && res.channelMsg.channelType == 8) {
                    console.log('当前渠道屏蔽诸葛')
                    Object.getOwnPropertyNames(window.TRACKER.__proto__).map(key => {
                        if (typeof window.TRACKER[key] === 'function') {
                          window.TRACKER[key] = function () {}
                        }
                    })
                }

                // 等待channelMsg返回才决定调不调userInfo和vipInfo
                if (!this.CHANNEL_NOT_LOGIN || this.isTfWechat) {
                  await that.getUserInfo(channelId);
                  that.getVipInfo(channelId);
                }
                this.byteDanceAppName = res.channelMsg.name
            })
            window.TRACKER.setChannelId(channelId);

            if(channelId*1===1) {
              PageGrayFilter()
            }
        },

        // 获取App的token
        async getAppToken () {
            if (this.platform.isYixinliApp) {
                let getToken = function() {
                    let bridge = new Bridge()

                    return new Promise(resolve => {
                        let methodName = `getToken${new Date().getTime()}`
                        window[methodName] = (jsonStr) => {
                            resolve(JSON.parse(jsonStr).token)
                        }
                        bridge.call('getToken', {
                            callbackName: methodName
                        })
                    })
                }
                let token = await getToken()
                if (token) {
                    return token
                }
            }
            return ''
        },

        // app、m站获取用户信息
        getAppUserMsg (token) {
            return this.$http.get(`https://m${APIS.env}.xinli001.com/ajax/get-user-header`, {
                params: { token }
            }).then(res => {
                return res.data.data.user
            })
        },

        // 获取平台用户信息
        getPlatformUserInfo (userId, mobile) {
            return this.$http.get(APIS.getUserInfoFromPlatfrom, {
                params: {userId, mobile}
            }).then(result => {
                return result.data.data
            })
        },

        // app、m站获取userKey
        getAppUserKey (userId, mobile) {
            return this.getUserKeyFromPlatfrom({userId, mobile}).then(userKey => {
                return userKey
            })
        },

        _copyText (content, cb) {
            let selection = window.getSelection()
            let range = document.createRange()
            let $code = document.createElement('div')
            $code.display = 'none'
            $code.innerHTML = content
            document.body.appendChild($code)
            range.selectNodeContents($code)
            selection.removeAllRanges()
            selection.addRange(range)
            if (document.execCommand('copy')) {
                //浏览器是否支持复制
                document.execCommand('copy')
                if (cb) {
                    cb()
                } else {
                    this.setTOASTTEXT('复制成功')
                }
            } else {
                this.setTOASTTEXT('浏览器不支持复制功能')
            }
            selection = null
            range = null
            document.body.removeChild($code)
        },

        handleAuth() {
            this.$http.get(APIS.h5activityAuth, {
                params: {
                    channelId: this.channelId,
                    url: location.href
                }
            }).then(res => {
                if (res.data.code === '302') {
                    location.href = res.data.data
                }
            })
        },

        doWxShareConfig,
        ...mapMutations([
            'setChannelId',
            // 'doWxConfig',
            'setUID'
        ]),
        ...mapActions([
            'getChannelMsg',
            'getWechatData',
            'promoBind'
        ]),

    }

}



// WEBPACK FOOTER //
// ./src/mixins/pageMixin.js